import React from 'reactn'
import Helmet from 'react-helmet'

export function JsonLd({ children }) {
  console.log("STRUCTURED DATA", JSON.stringify(children))
  return (
    <Helmet lang="en" encodeSpecialCharacters={false}>
      <script type="application/ld+json">{JSON.stringify(children)}</script>
    </Helmet>
  )
}